(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sasha-artwork-protection"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.SashaArtworkProtectionInitialized) return;

  window.SashaArtworkProtectionInitialized = true;

  const isProtectedArtwork = (target) => {
    return target instanceof Element && target.closest('[data-artwork-protected]');
  };

  document.addEventListener('contextmenu', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });

  document.addEventListener('selectstart', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
